import {PointOfContactForm} from "@/components/PointOfContacts/Form/PointOfContactForm.tsx";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {PointOfContactProps} from "@/interfaces/point-of-contact_types.ts";
import {getPointOfContactById} from "@/api/point-of-contact.ts";
import { GenericTableFactory } from "../_Shared/Table/Classes/Factory";
import { RouteButton } from "../Buttons";

export function CreatePointOfContacts() {
    return (
        <PointOfContactForm method="POST"/>
    )
}

export function UpdatePointOfContacts() {
    const { id } = useParams<string>()

    const [currentPointOfContact, setPointOfContact] = useState<PointOfContactProps>()

    useEffect(() => {
        if (!id) return

        const fetchPointOfContact = async () => {
            try {
                const data = await getPointOfContactById(id)
                setPointOfContact(data.data)
            } catch (error) {
                console.error("Error fetching point of contact:", error)
            }
        }

        fetchPointOfContact()
    }, [id])

    return (
        <>
            {currentPointOfContact && <PointOfContactForm method="PUT" formProps={currentPointOfContact}/>}
        </>
    )
}

export function PointOfContactList() {
    const table = GenericTableFactory.createPointOfContactTable()
    
    return (
        <>
            <div className="py-5 pl-5">
                <h1>Point of Contacts</h1>
            </div>

            {table.RenderTable()}
            
            <div className="flex flex-row justify-center gap-3 m-2">
                <RouteButton route={"/main_menu"} text="Back"/>
            </div>
        </>
    )
}